module.exports = __webpack_public_path__ + "static/img/min-candies.43ff09f0.png";